import WithRender from "../../templates/imageEditor/editorToolbar.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getEditor",
      "getFormat",
      "getActiveElement",
      "getPOIEVariables",
      "getReady",
      "getObject"
    ]),
    editor: function () {
      return this.getEditor;
    },
    format: function () {
      return this.getFormat;
    },
    formatType: function () {
      return this.format.width <= this.format.height;
    },
    isPortret: function () {
      return this.formatType;
    },
    isLandscape: function () {
      return !this.formatType;
    },
    getQuality: function () {
      if (this.getReady) {
        var POIEVariables = this.getPOIEVariables;
        var zoom = this.getEditor.zoom;
        var unit = (this.getEditor.dim.imageDimByFormat.unit / zoom) * 100;
        var inch_d = Math.sqrt(1 + 1);
        var px = unit / POIEVariables.cmToInch;
        var px_d = Math.sqrt(px * px + px * px);
        var ppi = px_d / inch_d;
        if (ppi < POIEVariables.ppiQuality[0]) return 1;
        if (ppi < POIEVariables.ppiQuality[1]) return 2;
        if (ppi < POIEVariables.ppiQuality[2]) return 3;
        if (ppi < POIEVariables.ppiQuality[3]) return 4;
        if (ppi < POIEVariables.ppiQuality[4]) return 5;
      } else {
        return 1;
      }
    },
    getActiveSliderValue: function () {
      var activeElement = this.getActiveElement;
      var text = "";
      if (activeElement.type == "main") {
        text = this.getEditor.zoom;
      } else {
        if (activeElement.type == "object") {
          text = 100 + this.getObject.objects[activeElement.index].zoom * 10;
        }
      }
      return text + "%";
    }
  },
  methods: {
    doPortret: function () {
      this.$store.dispatch("doPortret", { widget: this });
    },
    doLandscape: function () {
      this.$store.dispatch("doLandscape", { widget: this });
    },
    rotateImage: function () {
      if (this.getReady) {
        this.$store.commit("increaseRotateAngle");
        this.$store.commit("changeMarginView", 0);
        this.$store.dispatch("initEditor");
      }
    },

    deleteObject: function () {
      var activeElement = this.getActiveElement;
      if (typeof activeElement != "undefined") {
        if (
          ["object", "steckdosen", "cutouts"].indexOf(activeElement.type) > -1
        ) {
          var item = this.$store.state.imageEditor.object.objects[
            activeElement.index
          ];
          if (typeof item != "undefined") {
            if (item.subtype == "cropimage") {
              this.$store.commit("deleteObject", {
                index: activeElement.index
              });
            }
          }
          if (activeElement.type == "cutouts") {
            this.$store.dispatch("removeCutout", {
              index: activeElement.index
            });
          }
          if (activeElement.type == "steckdosen") {
            this.$store.dispatch("removeDosen", {
              index: activeElement.index
            });
          }
        }
      }
    },
    enableMarginView: function (flag) {
      this.$store.commit("changeMarginView", flag);
    },
    toggleCropMode: function (flag) {
      $("body").removeClass("active");
      if (flag) {
        $("body").addClass("active");
      }
      this.$store.dispatch("changeCropMode", flag);
    },
    toggleBckMode: function () {
      this.$store.dispatch("changeBckMode", !this.getEditor.bckMode | 0);
    },
    changeSlider: function (value) {
      var slider = $("#oieSlider");
      var oldVal = slider.slider("value");
      var newVal = oldVal + value;

      if (newVal < 100) newVal = 100;
      if (newVal > 150) newVal = 150;
      slider.slider("value", newVal);
    }
  },
  mounted: function () {
    jQuery("#oieSlider").slider({
      min: 100,
      max: 150,
      value: 1,
      create: (function (that) {
        return function () {
          that.$store.commit("changeZoom", jQuery(this).slider("value"));
        };
      })(this),
      slide: (function (that) {
        return function (event, ui) {
          var activeElement = that.getActiveElement;
          if (activeElement.type == "main") {
            that.$store.commit("changeZoom", ui.value);
          } else {
            that.$store.commit("updateZoom", {
              index: activeElement.index,
              zoom: (ui.value % 100) / 10
            });
          }
        };
      })(this),
      stop: (function (that) {
        return function (event, ui) {
          var activeElement = that.getActiveElement;
          if (activeElement.type == "main") {
            that.$store.commit("changeZoom", ui.value);
          } else {
            that.$store.commit("updateZoom", {
              index: activeElement.index,
              zoom: (ui.value % 100) / 10
            });
          }
        };
      })(this),
      change: (function (that) {
        return function (event, ui) {
          var activeElement = that.getActiveElement;
          if (activeElement.type == "main") {
            that.$store.commit("changeZoom", ui.value);
          } else {
            that.$store.commit("updateZoom", {
              index: activeElement.index,
              zoom: (ui.value % 100) / 10
            });
          }
        };
      })(this)
    });
  }
});
